import { useIntl } from "react-intl";

import { Button } from "@/components/atoms/Button";
import { ButtonVariantProps } from "@/components/atoms/Button/button-variants";
import Heart from "@/icons/__generated__/Heart/Heart20";
import HeartLarge from "@/icons/__generated__/Heart/Heart24";
import HeartFilled from "@/icons/__generated__/HeartFilled/HeartFilled20";
import HeartLargeFilled from "@/icons/__generated__/HeartFilled/HeartFilled24";

interface ListingSaveMainProps {
  appearance?: ButtonVariantProps["appearance"];
  isFav: boolean;
  isMDScreen: boolean;
  listingId: string;
  variant?: ButtonVariantProps["variant"];
  toggleFavorite: () => void;
  useLargeIcon?: boolean;
}

export const ListingSaveButton = ({
  appearance = "black",
  isFav,
  isMDScreen,
  listingId,
  variant = "default",
  toggleFavorite,
  useLargeIcon = false,
}: ListingSaveMainProps) => {
  const intl = useIntl();
  const favoriteTextMessage = intl.formatMessage({
    id: "listing.projects_save_main.button_unsave",
    defaultMessage: "Unsave",
  });
  const unFavoriteTextMessage = intl.formatMessage({
    id: "listing.projects_save_main.button_save",
    defaultMessage: "Save",
  });
  const text = isFav ? favoriteTextMessage : unFavoriteTextMessage;
  const heartIcon = isFav ? (
    <span data-testing-id="icon-filled-heart">
      {useLargeIcon ? <HeartLargeFilled /> : <HeartFilled />}
    </span>
  ) : (
    <span data-testing-id="icon-empty-heart">
      {useLargeIcon ? <HeartLarge /> : <Heart />}
    </span>
  );

  return (
    <Button
      appearance={appearance}
      onClick={toggleFavorite}
      id={`favorites-btn-${listingId}`}
      className="[&>span]:tw-flex [&>span]:tw-items-center [&>span]:tw-gap-4"
      variant={variant}
      iconOnly={!isMDScreen}
      data-testing-id="saveButton"
    >
      {heartIcon}
      {isMDScreen && text}
    </Button>
  );
};
